"use client";

import React, { useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Clock, PhoneCall, ShieldCheck, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function RequestService() {
  const shouldReduceMotion = useReducedMotion();
  useEffect(() => {
    const cssHref = "https://d3ey4dbjkt2f6s.cloudfront.net/assets/external/work_request_embed.css";
    const jsSrc = "https://d3ey4dbjkt2f6s.cloudfront.net/assets/static_link/work_request_embed_snippet.js";

    // Safely inject Jobber stylesheet if not already present
    if (!document.querySelector(`link[href="${cssHref}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssHref;
      link.media = "screen";
      document.head.appendChild(link);
    }

    // Safely inject Jobber embed snippet script if not already present
    if (!document.querySelector(`script[src="${jsSrc}"]`)) {
      const script = document.createElement("script");
      script.src = jsSrc;
      script.setAttribute("clienthub_id", "476c5fe2-f16a-4108-ad33-1763e02c3dad-4972587");
      script.setAttribute("form_url", "https://clienthub.getjobber.com/client_hubs/476c5fe2-f16a-4108-ad33-1763e02c3dad/public/work_request/embedded_work_request_form?form_id=4972587");
      document.body.appendChild(script);
    }
  }, []);
  return <section id="request-service-form" data-nav="light" className="relative bg-background text-foreground py-16 md:py-24 border-b border-border selection:bg-primary selection:text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Technical Spec Top Bar */}
        <div className="mb-10 flex flex-wrap items-center justify-between gap-4 border-b border-border pb-4">
          <div className="flex items-center gap-3">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-primary" />
            </span>
            <span className="font-mono text-xs uppercase tracking-widest text-primary font-bold">
              TriServe 24/7 Field Dispatch • Direct Local Response
            </span>
          </div>
          <div className="flex items-center gap-4 text-xs font-medium text-muted-foreground">
            <span>Maryland</span>
            <span>•</span>
            <span>Washington DC</span>
            <span>•</span>
            <span>Northern Virginia</span>
          </div>
        </div>

        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.32,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-3xl mx-auto text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-primary/10 border border-primary/20 text-primary text-xs font-bold uppercase tracking-wider mb-4">
            <Zap className="size-3.5" />
            Priority Incident Intake
          </div>
          <h2 className="font-default text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-foreground leading-tight mb-4">
            Request immediate dispatch or property inspection
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
            Connect directly with local technicians across Maryland, DC, and
            Northern Virginia. No call centers — your details transmit straight to
            our nearest emergency crew.
          </p>
        </motion.div>

        {/* Form Container */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-card text-card-foreground rounded-lg border border-border p-6 sm:p-10 shadow-md">
            {/* Quick Dial Utility Bar inside Card */}
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 rounded-md bg-muted border border-border/80 mb-8">
              <div className="flex items-center gap-3">
                <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <PhoneCall className="size-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">
                    Active Water or Fire Emergency?
                  </div>
                  <div className="text-sm font-bold text-foreground">
                    Immediate phone dispatch available 24/7
                  </div>
                </div>
              </div>
              <Button asChild variant="default" className="w-full sm:w-auto font-mono text-sm font-bold h-10 px-5">
                <a href="tel:8554356631">
                  <Zap className="size-4 text-accent fill-accent" />
                  Call 855-435-6631
                </a>
              </Button>
            </div>

            {/* Jobber Work Request Embed Mount */}
            <div id="476c5fe2-f16a-4108-ad33-1763e02c3dad-4972587"></div>
          </div>
        </div>
      </div>
    </section>;
}